(() => {
  // src/collection.ts
  (() => {
    const fadeInGrid = (grid) => {
      grid.classList.remove("collection__grid--entering");
      void grid.offsetWidth;
      grid.classList.add("collection__grid--entering");
    };
    const loadPage = async (section, url) => {
      section.setAttribute("aria-busy", "true");
      try {
        const html = await window.HotelCollection.shopFetch.html(
          "collection",
          url
        );
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrids = doc.querySelectorAll(".collection__grid");
        const oldGrids = section.querySelectorAll(".collection__grid");
        oldGrids.forEach((oldGrid, i) => {
          if (!newGrids[i]) return;
          oldGrid.innerHTML = newGrids[i].innerHTML;
          fadeInGrid(oldGrid);
        });
        history.pushState({ ajaxUrl: url }, "", url);
        section.removeAttribute("aria-busy");
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      } catch (e) {
        section.removeAttribute("aria-busy");
        window.location.href = url;
      }
    };
    document.addEventListener("click", (e) => {
      const link = e.target.closest("a[href]");
      if (!link || !link.closest(".pagination")) return;
      const section = link.closest("[data-ajax-pagination]");
      if (!section) return;
      e.preventDefault();
      loadPage(section, link.href);
    });
    window.addEventListener("popstate", (e) => {
      var _a, _b;
      if ((_a = e.state) == null ? void 0 : _a.collectionHandle) return;
      const section = document.querySelector("[data-ajax-pagination]");
      if (!section) return;
      const url = ((_b = e.state) == null ? void 0 : _b.ajaxUrl) || location.href;
      loadPage(section, url);
    });
    window.HotelCollection = window.HotelCollection || {};
    window.HotelCollection.fadeInCollectionGrids = () => {
      document.querySelectorAll(".collection__grid").forEach(fadeInGrid);
    };
  })();
})();
